import { render, staticRenderFns } from "./OnlineTeaching.vue?vue&type=template&id=98bd0138&scoped=true&"
import script from "./OnlineTeaching.vue?vue&type=script&lang=js&"
export * from "./OnlineTeaching.vue?vue&type=script&lang=js&"
import style0 from "./OnlineTeaching.vue?vue&type=style&index=0&id=98bd0138&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bd0138",
  null
  
)

export default component.exports